import { Grid, Typography } from '@mui/material'
import React from 'react'

interface ErrorLabelProps {
  label: string | React.ReactNode
}

export const ErrorLabel: React.FC<ErrorLabelProps> = ({ label }) => {
  if (!label) {
    return null
  }

  return (
    <Grid container direction='row'>
      <Grid item sx={{ width: '2px', backgroundColor: 'error.main' }} />
      <Grid item sx={{ pl: '10px', pr: '10px', pt: '5px', pb: '5px', backgroundColor: 'flareSecondary.main' }}>
        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: 'text.primary', lineHeight: '16px' }}>
          {label}
        </Typography>
      </Grid>
    </Grid>
  )
}
